import { localStorageHelper } from "./localStorageHelper";
import { store } from "./../redux/store";
import axios from "axios";
import {
  setErrorMsg,
  setLoadingSpinner,
} from "../redux/reducers/settingsSlice";
import {
  PROFILE_KEY,
  SESSOIN_EXPIRY_KEY,
  supportEmail,
  USE_COOKIE_LOGIN,
} from "../utils/Constants";
import moment from "moment";

const { REACT_APP_BASE_URL } = process.env;

declare module "axios" {
  interface AxiosRequestConfig {
    // Set for screens that show their own inline loader instead of the global spinner.
    skipGlobalLoader?: boolean;
  }
}

const API = axios.create({
  baseURL: REACT_APP_BASE_URL,
  withCredentials: USE_COOKIE_LOGIN,
});

API.interceptors.request.use(async (req) => {
  if (!req.skipGlobalLoader) {
    store.dispatch(setLoadingSpinner(true));
  }
  await new Promise((resolve) => setTimeout(resolve, 500));

  if (!USE_COOKIE_LOGIN) {
    const accessToken = localStorageHelper.load(PROFILE_KEY)?.access_token;
    if (typeof accessToken !== "undefined") {
      req.headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    }
  }
  return req;
});

API.interceptors.response.use(
  (response) => {
    if (!response.config.skipGlobalLoader) {
      store.dispatch(setLoadingSpinner(false));
    }
    return response;
  },
  (error) => {
    if (!error?.config?.skipGlobalLoader) {
      store.dispatch(setLoadingSpinner(false));
    }
    const requestUrl = error?.config?.url ?? "";
    const isSalesDropApiError = requestUrl.includes("/operations-order/v1/sales-drop");

    if (isSalesDropApiError) {
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error.message);
    }

    if (error.response.status === 401) {
      logout();
    } else if (error.response.status === 500) {
      console.log("Internal Server error");
    } else {
      if (isSessionExpired() && !USE_COOKIE_LOGIN) {
        logout();
      } else {
        store.dispatch(
          setErrorMsg({
            title: "Something went wrong",
            message: `Please exit or contact us on ${supportEmail}`,
          })
        );
      }
    }

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error.message);
  }
);

function isSessionExpired() {
  let expiryTime = localStorageHelper.load(SESSOIN_EXPIRY_KEY);
  expiryTime = moment(expiryTime);
  let currentTime = moment();
  return expiryTime.isBefore(currentTime);
}

/**
 * Logs out the user.
 */
function logout() {
  localStorageHelper.remove(PROFILE_KEY);
  window.location.reload();
}

/**
 * Executes a get request.
 * @param url - The url to be appended to the base url.
 * @returns
 */
export const executeGetRequest = async (url: string) => {
  try {
    const response = await API.get(getFullURL(url));
    let { data } = await response;
    return data;
  } catch (error) {
    console.log(error);
  }
};

/**
 *
 * @param url - The url to be appended to the base url.
 * @returns - The full url.
 */
export function getFullURL(url: string) {
  return REACT_APP_BASE_URL + url;
}

export default API;
